import React from "react";
import Body from "@/ui/Body";
import classes from "./styles.module.scss";
import Image from "@/ui/Image";
import Title from "@/ui/Title";
import { values_helper } from "@/helpers/values_helper";

export const ValuesCarousel = ({ brands = [], title, useDefault }) => {
  const defaultItems = useDefault ? values_helper.fetch() : [];

  const items = Array.isArray(brands) && brands.length ? [...defaultItems, ...brands] : defaultItems;

  if (items.length === 0) {
    return null;
  }
  
  return (
    <div className={classes.section}>
      <div className={classes.header_cont}>
        <Title
          tag="h2"
          title={title}
          className={`highlight primary ${classes.header}`}
          highlight={true}
          variant="primary"
        />
      </div>

      <div className={classes.brands}>
        <div className={classes.container}>
          {items.map((brand, index) => {
            const iconSrc = typeof brand.icon === "string" ? brand.icon : brand.icon?.url;

            return (
              <div key={brand.id || index} className={classes.profile}>
                <div className={classes.leader_card}>
                  <div className={classes.content}>
                    <div className={classes.icon}>
                      <Image img={iconSrc ?? "https://placehold.co/40"} size="80x80" alt={brand.title} />
                    </div>
                    <div className={classes.title}>{brand.title}</div>

                    <Body className={classes.description} body={brand.description} />
                    <div className={classes.image_container}>
                      <img alt={brand.title} src="/specialism_image.svg" className={classes.bottom_img} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ValuesCarousel;
